import React, {useState} from "react";
import Modal from "../common/Modal";
import {changePassword} from "../../api/apiUser";
import {Popover, Whisper} from "rsuite";

export const ResetPasswordMember = ({member, successCallback, errorCallback}) => {

    const [showModal, setShowModal] = useState(false);

    const handleResetPassword = async () => {
        await changePassword({}, member.id)
            .then(() => {
                successCallback('Le mot de passe a été réinitialisé.');
                cancelModal();
            })
            .catch(() => {
                errorCallback('Une erreur est survenue.')
                cancelModal();
            });
    }

    const cancelModal = () => setShowModal(false);

    return (
        <>
            <Whisper placement="top" trigger="hover" speaker={<Popover><span>Réinitialiser le mot de passe à "<strong>password</strong>"</span></Popover>}>
                <button className="button-link button-icon members__delete" onClick={() => {setShowModal(true)}}>
                    <i className="fa fa-key"/>
                </button>
            </Whisper>
            {showModal &&
                <Modal
                    title="Réinitialiser le mot de passe"
                    description={`Etes-vous sûr de vouloir réinitialiser le mot de passe de <strong>${member.firstname} ${member.lastname}</strong>?`}
                    buttons={[
                        {label: `Oui, réinitialiser le mot de passe`, callback: () => handleResetPassword()}
                    ]}
                    cancelCallback={() => cancelModal()}
                />
            }
        </>
    )
}